module.exports = __webpack_public_path__ + "img/bird.6d4712b5.gif";